import ErrorBoundary from './ErrorBoundary.jsx';

export default ErrorBoundary;